<template>
    <section id="kids">
        <div class="kids-content">
            <div class="content">
                <h2 class="title">{{$t('kidsSection.title')}}</h2>
                <p class="text">
                    {{$t('kidsSection.text1')}}
                </p>
                <p class="text">
                    {{$t('kidsSection.text2')}}
                </p>
                <div class="learn-more content-buttons">
                  <a href="#modal_kids" class="learn-btn open-modal btn-desktop">
                    {{$t('kidsSection.moreBtn')}}
                  </a>

                  <div class="m-buttons-wrap">
                    <a href="#modal_kids" @click="changeButtonText()" class="learn-btn open-modal border-btn">
                      {{details_opened ? $t('buttons.hide') : $t('longStaySection.moreBtn')}}
                    </a>
                  </div>
                  <div class="accordion">
                    <div class="info">
                      <h2 class="title">Free for kids</h2>
                      <p class="content-description">{{$t('kidsModal.p1')}}</p>
                      <p class="content-description">{{$t('kidsModal.p2')}}</p>
                      <p class="content-description">{{$t('kidsModal.p3')}}</p>
                      <ul>
                        <li>{{$t('kidsModal.p4')}}</li>
                        <li>{{$t('kidsModal.p5')}}</li>
                        <li>{{$t('kidsModal.p6')}}</li>
                      </ul>
                      <p class="content-description">{{$t('kidsModal.p7')}}</p>
                      <p class="content-description">{{$t('kidsModal.p8')}}</p>
                      <p class="content-description">{{$t('kidsModal.p9')}}</p>
                    </div>
                  </div>
                </div>
            </div>
        </div>
        <div class="kids-images">
          <img src="/img/kids/kids.jpg" alt="">
      </div>
    </section>
</template>

<script>
    export default {
        name:'Kids',
        data() {
          return {
            details_opened: false
          }
        },
        methods: {
          changeButtonText() {
            this.details_opened = !this.details_opened;
          }
        }
    }
</script>
